import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import 'antd/dist/antd.css';

import SummaryView from '../../components/fpp/SummaryView';
import QuestionMainSet from '../../components/fpp/QuestionsMainSet';
import QuestionsReviewView from '../../components/fpp/QuestionsReviewView';
import FPPActionCreators from '../../actions/FPPActionCreators';

class AddAssessmentContainer extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      getFPPMainQuestions: PropTypes.func.isRequired,
      getRecommendation: PropTypes.func.isRequired,
    }).isRequired,
    router: PropTypes.shape({
      navigate: PropTypes.func.isRequired,
    }).isRequired,
    medicalRecordId: PropTypes.string.isRequired,
  };

  state = {
    questions: [],
    answers: [],
    phase: 1,
    startFromEnd: false,
    recommendation: null,
    additionalQuestionsSubmissionId: null,
    askAdditionalQuestions: false,
  };

  componentDidMount() {
    const { getFPPMainQuestions } = this.props.actions;

    this.surveyQuestions2 = getFPPMainQuestions()
      .then((response) => {
        this.setState({ questions: response });
      });

    window.scroll(0, 0);
  }

  getSummaryView = () => {
    // get recommendation from state, format, send into summaryView
    const { router } = this.props;
    const {
      recommendation: recommendationResponse,
      questions: completeQuestions,
      askAdditionalQuestions,
    } = this.state;
    const recommendation = {
      ...recommendationResponse,
      timestamp: recommendationResponse.createdAt,
    };
    return (
      <SummaryView
        recommendation={recommendation}
        nextPhase={this.nextPhase}
        router={router}
        questionSet={completeQuestions.filter(value => (value.question.questionGroup === 'B'))}
        askAdditionalQuestions={askAdditionalQuestions}
      />
    );
  };

  nextPhase = (inputAnswers) => {
    const {
      phase,
      answers,
      questions,
      additionalQuestionsSubmissionId,
    } = this.state;
    const {
      actions: {
        getRecommendation,
        submitAdditionalQuestions,
      },
      medicalRecordId,
    } = this.props;
    let newAnswerArray = [];
    let formattedAnswers = {};
    let additionalQuestionsAnswersIndexOffset = 0;

    switch (phase) {
      case 1:
        // save answers and go to phase 2
        newAnswerArray = [...answers];
        questions.forEach((value, index) => {
          // overwrite existing saved answers
          newAnswerArray[index] = inputAnswers[index];
        });
        this.setState({
          phase: phase + 1,
          answers: newAnswerArray,
          startFromEnd: false,
        });
        window.scroll(0, 0);
        break;
      case 2:
        // send answers & query for summary view info here and go to next state
        formattedAnswers = { ...this.formatAnswersToSend() };
        getRecommendation(formattedAnswers)
          .then((response) => {
            if (response) {
              this.setState({
                askAdditionalQuestions: response.askAdditionalQuestions,
                additionalQuestionsSubmissionId: response.id,
                recommendation: response,
                phase: phase + 1,
              });
              window.scroll(0, 0);
            }
          });
        break;
      case 3:
        // append entire answers here
        newAnswerArray = [...answers];
        additionalQuestionsAnswersIndexOffset = questions.filter(value => (value.question.questionGroup === 'A')).length;
        inputAnswers.forEach((value, index) => {
          // overwrite existing saved answers
          newAnswerArray[additionalQuestionsAnswersIndexOffset + index] = inputAnswers[index];
        });
        this.setState({
          answers: newAnswerArray,
        }, () => {
          formattedAnswers = { ...this.formatAnswersToSend(), questionGroup: ['A', 'B'], medicalRecordId: parseInt(medicalRecordId, 10) };
          submitAdditionalQuestions(
            formattedAnswers,
            additionalQuestionsSubmissionId
          )
            .then(() => {
              window.history.back();
            });
        });
        break;
      default: break;
    }
  };

  previousPhase = () => {
    const { phase } = this.state;
    switch (phase) {
      case 1:
        break;
      case 2:
        this.setState({
          phase: phase - 1,
          startFromEnd: true,
        });
        break;
      case 3:
        this.setState({
          phase: phase - 1,
        });
        break;
      default: break;
    }
  };

  formatAnswersToSend = () => {
    const {
      answers,
      questions,
    } = this.state;

    const {
      surveyId,
      medicalRecordId,
    } = this.props;
    const newArray = [];

    answers.forEach((item, index) => {
      if (typeof item !== 'undefined') {
        const { selectedAnswers } = item;

        selectedAnswers.forEach((ans) => {
          const { id: surveyQuestionAnswerId } = ans; // map given ans selections to send out format
          const {
            question: {
              id: surveyQuestionId,
            },
          } = questions[index];

          newArray.push({
            surveyId: parseInt(surveyId, 10),
            surveyQuestionAnswerId,
            surveyQuestionId,
          });
        });
      }
    });

    return {
      surveyId: parseInt(surveyId, 10),
      medicalRecordId: parseInt(medicalRecordId, 10),
      answers: newArray,
    };
  };


  render() {
    const {
      phase,
      answers,
      startFromEnd,
      questions: completeQuestions,
    } = this.state;
    const {
      router,
      medicalRecordId,
    } = this.props;
    return (
      <div>
        {completeQuestions.length ? (() => {
          switch (phase) {
            case 1:
              // main questions
              return (
                <div>
                  <QuestionMainSet
                    questionSet={completeQuestions.filter(value => (value.question.questionGroup === 'A'))}
                    nextPhase={this.nextPhase}
                    previousPhase={this.previousPhase}
                    resumeAnswerSet={answers}
                    startFromEnd={startFromEnd}
                    router={router}
                    medicalRecordId={medicalRecordId}
                  />
                  <br />
                </div>
              );
            case 2:
              // review answers
              return (
                <div>
                  <QuestionsReviewView
                    questionSet={completeQuestions.filter(value => (value.question.questionGroup === 'A'))}
                    nextPhase={this.nextPhase}
                    previousPhase={this.previousPhase}
                    resumeAnswerSet={answers}
                  />
                  <br />
                </div>
              );
            case 3:
              // get summary & additional questions
              return (
                <div>
                  {this.getSummaryView()}
                  <br />
                </div>
              );
            default: return null;
          }
        })() : null}
      </div>
    );
  }
}

// eslint-disable-next-line
const mapStateToProps = state => {
  return { state };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    ...FPPActionCreators,
  }, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddAssessmentContainer);



// WEBPACK FOOTER //
// ./src/containers/fpp/AddAssessmentContainer.js